import { css } from '@emotion/css';

export const fromInfo = css`
  margin: 4px 0;
  padding: 2px 4px;
  font-size: 12px;
  color: var(--ant-primary-color);
  background-color: var(--ant-primary-1);
  border-radius: 2px;
  text-wrap: nowrap;
`;

export const fromBtn = css`
  margin: 0 4px !important;
  padding: 2px 4px !important;
  font-size: 12px !important;
  color: var(--ant-primary-color) !important;
  background-color: var(--ant-primary-1) !important;
  border-radius: 2px !important;
  text-wrap: nowrap !important;
  height: 24px;
`;
